module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Knife1-cc6cdcca8be19c1226c569ec1fd5d3bd.svg";